import { getEnv } from '@lusha-app/env';
export const NO_DATA_FEEDBACK = 'noDataFeedback';
export const GLOBAL_COPY_TO_CLIPBOARD = 'copyToClipboard';
export const GLOBAL_USER_LEGAL = 'userLegal';
export const COMPOSE_EMAIL = 'composeEmail';
export const USER_REFERRAL_TAB = 'userReferralTab';
export const USER_REFERRAL_TAB_EXPOSED = 'referralTabExposed';
export const USER_REFERRAL_TAB_CLICKED = 'referralTabClicked';
export const CONTACT_GO_TO_PROFILE = 'contactGoToProfile';
export const USER_NEW_ONBOARDING = 'userNewOnboarding';
export const FREE_TRAIL_SELF_SERVICE = 'freeTrialSelfService';
export const GLOBAL_USER_PROSPECTING_CONTACT_CLICKED = 'userProspectingContactClicked';
export const INTEGRATION_SETUP = 'integrationSetup';
export const GLOBAL_USER_SHOW_CONTACT = 'userShowContact';
export const UGC = 'ugc';
export const INTEGRATION_TEAM_NAME = 'integrations';
export const PLUGIN_TEAM_NAME = 'plugin';
export const GROWTH_TEAM_NAME = 'growth';
export const ACCOUNT_TEAM_NAME = 'account';
export const USER_FEEDBACK = 'userFeedback';
export const SAVE_TO_VALUE_TYPES = {
    LIST: 'lusha',
    CRM: 'crm',
    SAVE: 'save',
    SEQUENCE: 'sequence',
};
export const EVENT_TOPICS = {
    GLOBAL_EVENTS: 'global-events',
    PLUGIN: 'plugin',
    COMMUNITY: 'community',
    CREDITS: 'credits',
    ONBOARDING: 'onboarding',
    FREE_TRIAL: 'free-trial',
    UGC: 'ugc',
};
export const eventNameToCategory = {
    [NO_DATA_FEEDBACK]: EVENT_TOPICS.PLUGIN,
    [GLOBAL_COPY_TO_CLIPBOARD]: EVENT_TOPICS.GLOBAL_EVENTS,
    [GLOBAL_USER_LEGAL]: EVENT_TOPICS.GLOBAL_EVENTS,
    [COMPOSE_EMAIL]: EVENT_TOPICS.COMMUNITY,
    [CONTACT_GO_TO_PROFILE]: EVENT_TOPICS.GLOBAL_EVENTS,
    [GLOBAL_USER_PROSPECTING_CONTACT_CLICKED]: EVENT_TOPICS.GLOBAL_EVENTS,
    [USER_NEW_ONBOARDING]: EVENT_TOPICS.ONBOARDING,
    [FREE_TRAIL_SELF_SERVICE]: EVENT_TOPICS.FREE_TRIAL,
    [INTEGRATION_SETUP]: EVENT_TOPICS.GLOBAL_EVENTS,
    [UGC]: EVENT_TOPICS.UGC,
    [GLOBAL_USER_SHOW_CONTACT]: EVENT_TOPICS.GLOBAL_EVENTS,
    [USER_FEEDBACK]: EVENT_TOPICS.GLOBAL_EVENTS,
};
const schemaVersionIdByEnv = {
    local: {
        [NO_DATA_FEEDBACK]: 'e11dfbe9-0b27-42db-8cc0-8175c243e826',
        [GLOBAL_COPY_TO_CLIPBOARD]: '190bb481-83ef-4fe7-9d20-0ffb3d1bdd37',
        [GLOBAL_USER_LEGAL]: '85ad37e8-5137-4e95-8e60-aeb636fb336c',
        [COMPOSE_EMAIL]: 'd061622a-57dc-48a5-bfcc-953395b13248',
        [CONTACT_GO_TO_PROFILE]: '9e6bb24e-ec17-4781-ab9e-aef96910fa1e',
        [GLOBAL_USER_PROSPECTING_CONTACT_CLICKED]: 'e31a23e9-d052-4771-b0b2-51bfdde7c448',
        [USER_NEW_ONBOARDING]: 'e60daa4f-bb0b-43e1-8744-efe30f23c9dc',
        [FREE_TRAIL_SELF_SERVICE]: 'f352e67e-6ce8-4f74-928c-9183709e1d94',
        [INTEGRATION_SETUP]: '15ac4841-60e2-4d13-839b-6a7dc94d6b56',
        [GLOBAL_USER_SHOW_CONTACT]: 'd3950341-3faf-42b4-8afb-7eb90cebf4f6',
        [UGC]: 'd04735f2-0ad4-4f48-bd54-7065272c00cf',
        [USER_FEEDBACK]: 'd989bddd-a3ad-43cf-8b23-13f83b7bc143',
    },
    staging: {
        [NO_DATA_FEEDBACK]: 'e11dfbe9-0b27-42db-8cc0-8175c243e826',
        [GLOBAL_COPY_TO_CLIPBOARD]: 'a059cda9-b46e-4524-963e-d7f6f33c090c',
        [GLOBAL_USER_LEGAL]: '4fa8ac88-b543-45cb-89d4-75b1ac06afbd',
        [COMPOSE_EMAIL]: 'd061622a-57dc-48a5-bfcc-953395b13248',
        [CONTACT_GO_TO_PROFILE]: 'a503f6d3-12bc-4c9c-b672-20af34a913f6',
        [GLOBAL_USER_PROSPECTING_CONTACT_CLICKED]: '21c21f66-7156-465b-ac10-99e54ec662fc',
        [USER_NEW_ONBOARDING]: 'ed91029a-a5c4-43b9-bc40-6f639a9c04a1',
        [FREE_TRAIL_SELF_SERVICE]: '152e9f9b-2f58-4856-8aee-88135c2a386b',
        [INTEGRATION_SETUP]: '2344c1db-d680-42cd-8e27-82e2b18117bd',
        [GLOBAL_USER_SHOW_CONTACT]: 'a1d99522-6302-461c-8c15-c3c0addbe2ff',
        [UGC]: '0204b13e-5be8-4bad-b77d-1f7fc966dd05',
        [USER_FEEDBACK]: '23879e0f-6870-45ef-8665-96aef93b33a3',
    },
    production: {
        [NO_DATA_FEEDBACK]: '0c06dabe-756e-43fa-ba78-f708700bbace',
        [GLOBAL_COPY_TO_CLIPBOARD]: 'cbc4c326-3fb0-4b93-8afe-14f764045ea9',
        [GLOBAL_USER_LEGAL]: '99db85ba-73a6-41c4-b927-2ef4b54d4348',
        [COMPOSE_EMAIL]: 'a0e571c0-1e6b-40ba-b5b5-2440b513d098',
        [CONTACT_GO_TO_PROFILE]: '74f65085-7bf5-472b-8d62-482ad441968d',
        [GLOBAL_USER_PROSPECTING_CONTACT_CLICKED]: 'd4d152b7-b404-49a2-9cb9-35d31b432d67',
        [USER_NEW_ONBOARDING]: '37cb24a9-4c27-4d3e-99eb-a75d522c11f0',
        [FREE_TRAIL_SELF_SERVICE]: '0a1d079d-1afd-4498-9437-64feb396ef4c',
        [INTEGRATION_SETUP]: '88e1fd0c-b065-4e0f-8e8e-b03b939d6bb3',
        [GLOBAL_USER_SHOW_CONTACT]: 'f678bca7-1c6f-4f66-af36-59191bf257c9',
        [UGC]: '8d1ba771-03ee-4eb7-85fd-682df4e69543',
        [USER_FEEDBACK]: 'bb9ad8f6-288a-4671-881a-965908c4893b',
    },
};
function getSchemasVersionsByEnv() {
    const env = getEnv();
    return schemaVersionIdByEnv[env] || schemaVersionIdByEnv.staging;
}
export default getSchemasVersionsByEnv();
